<template>
  <div>
    <b-input-group prepend="Subject" class="mb-2 mr-sm-2" v-if="!hideSubject">
      <b-form-input
        id="inline-form-input-username"
        placeholder="Subject"
        v-model="form.subject"
        :class="{ error: v.form.subject.$error }"
      ></b-form-input>
    </b-input-group>
    <b-input-group prepend="From" class="mb-2 mr-sm-2">
      <b-form-input
        id="inline-form-input-username"
        placeholder="From"
        disabled
        :value="form.ticket_email_plugin"
      ></b-form-input>
    </b-input-group>
    <div
      class="target-email mb-2"
      :class="{ error: v.form.target_email.$error }"
    >
      To

      <InputTag
        :limit="0"
        hideBorder
        v-model="form.target_email"
        :disabledFirstValue="!form.is_forward"
        :options="contactForwardEmailList"
        placeholder="Type Email To Forward And Press Enter"
        emailValidation
        :disabled="!form.is_forward"
        :closeOnSelect="false"
        :allowNew="allowNew"
      />
      <span class="cursor-pointer text-link text-info" @click="addCC">
        CC
      </span>
    </div>
    <div class="target-email mb-2" v-if="isCCEmail">
      CC
      <InputTag
        :limit="0"
        hideBorder
        v-model="form.cc_email"
        placeholder="Type Email To CC And Press Enter"
        emailValidation
        name="cc-email"
        autocomplete="section-cc email"
        allowNew
      />
    </div>

    <TextEditorTiny
      textFloat=""
      :rows="4"
      :defaultEdit="false"
      :value="form.body"
      ref="replyBox"
      :name="nameRef"
      placeholder="Type something..."
      class="activity-input"
      @onDataChange="(val) => (form.body = val)"
      :showTemplate="true"
      @addFileAttachment="addFileAttachment"
      addFile
      :variables="['conversation_url']"
      hideGmailQuoteOnInit
    >
      <div
        class="preview-message floating"
        @click="toggleQuotePreview()"
        :class="[
          this?.$refs?.replyBox?.$refs?.[this.nameRef]?.list?.length > 0
            ? 'has-file'
            : '',
        ]"
      ></div>
    </TextEditorTiny>
    <!-- :v="$v.form.body" -->
  </div>
</template>
<script>
import QuoteText from "@/mixins/ticket/quoteText";
import InputTag from "@/components/inputs/InputTag.vue";
import TextEditorTiny from "@/components/inputs/TextEditorsTiny";
export default {
  mixins: [QuoteText],
  components: { InputTag, TextEditorTiny },
  props: {
    form: {
      type: Object,
      required: true,
    },
    setting: {
      type: Object,
      required: true,
    },
    nameRef: {
      type: String,
      default: "formBody",
    },
    v: {
      required: false,
    },
    hideSubject: {
      required: false,
      default: false,
      type: Boolean,
    },
    allowNew: {
      required: false,
      default: false,
      type: Boolean,
    },
    contactForwardEmailList: {
      required: false,
      type: Array,
    },
  },
  data() {
    return {
      isCCEmail: false,
    };
  },
  computed: {
    async attachFile() {
      await this.$nextTick();
      return this?.$refs?.replyBox?.$refs?.[this.nameRef]?.list?.length || 0;
    },
  },
  methods: {
    addFileAttachment(value) {
      this.$emit("addFileAttachment", value);
    },
    addCC() {
      if (!this.isCCEmail) this.form.cc_email = [];
      this.isCCEmail = !this.isCCEmail;
    },
    normalizeQuotes() {
      return this.normalizeQuotesBeforeSend();
    },
  },
};
</script>
<style lang="scss">
@import "./style/index.scss";
.target-email {
  display: flex;
  align-items: center;
  border: 1px solid #d8dbe0;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  column-gap: 10px;
}
</style>
